<div class="container">
  <p class="text-center fs-3">MySQL</p>    
    <p class="text-center fs-4">Consulta reactiva con httpResource</p>  
    <!-- Al referencia el signal usersResourceValue aqui ya se evalua al entrar en la pagina -->
    <p class="text-center fs-4">Numero de usuarios: {{usersResourceValue().length}}</p>  
  @if (usersResourceState() === 'loading') {
    <p class="text-center">Cargando usuarios...</p>
  } @else if (usersResourceState() === 'error') {
    <p class="text-center text-danger">Error al cargar usuarios.</p>
  } @else {
    <div class="row">
      <div class="mat-elevation-z8 my-3">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="usuario_id">
            <th mat-header-cell *matHeaderCellDef>Usuario ID</th>
            <td mat-cell *matCellDef="let usuario "> {{ usuario.usuario_id}} </td>
          </ng-container>
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let usuario "> {{ usuario.nombre}} </td>
          </ng-container>
          <ng-container matColumnDef="apellidos">
            <th mat-header-cell *matHeaderCellDef>Apellidos</th>
            <td mat-cell *matCellDef="let usuario "> {{usuario.apellidos}} </td>
          </ng-container>
          <ng-container matColumnDef="direccion">
            <th mat-header-cell *matHeaderCellDef>Direccion</th>
            <td mat-cell *matCellDef="let usuario "> {{usuario.direccion}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row (click)="clickedRow(row)" [class.demo-row-is-clicked]="clickedRowSelected(row)"  *matRowDef="let row; columns: columnsToDisplay"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
      </div>
      </div>
    }
   
      <div class="row">
        <app-mysql-detalle-usuario            
            [usuario]="filaUsuarioSeleccionado" [(usuarioSignal)]="usuarioSignal" (cambioEnUsuarios)="cambioEnUsuarios($event)">
        </app-mysql-detalle-usuario>
      </div>
    
</div>
